import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Components
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Typography } from '@mui/material';

//Actions
import {
    deletePMUserCloseModal,
    deletePMUserRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteUser = (props) => {
    const { tableRef } = props;
    const dispatch = useDispatch();

    const { messages } = useIntl();

    const { deleteUser, deleteUserLoading, openModal, users } = useSelector(state => state.usersDeleteUserRedux);

    const closeModal = () => {
        dispatch(deletePMUserCloseModal());
        dispatch(clearRedux("DELETE_PMUSERS"));
    }

    const deleteUsers = () => {
        dispatch(deletePMUserRequest(users))
    }

    useEffect(() => {
        if (deleteUser) {
            NotificationManager.success(
                messages['pmusers_users_have_been_removed'],
                messages['pmusers_delete_users'],
                3000
            );
            tableRef?.current?.getData();
            dispatch(clearRedux("DELETE_PMUSERS"));
        }
    }, [deleteUser])

    return (
        <Modal
            open={openModal}
            title={messages['pmusers_delete_users']}
            size="small"
            handleClose={() => closeModal()}
            position="right"
            loading={deleteUserLoading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <Typography
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messages['pmusers_do_you_want_to_delete']}
                    </Typography>
                    {
                        (users && users?.length) &&
                        <ul style={{ marginTop: 5 }}>
                            {
                                users.map((item, key) => {
                                    return (
                                        <li key={key}>
                                            {`${item?.firstName || ''} ${item?.lastName || ''}`}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <div>
                    <Button
                        className="btn btn-cancel"
                        onClick={(e) => closeModal()}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={(e) => deleteUsers()}
                    >
                        {messages['delete']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default DeleteUser;